import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';

import { GhostPost } from '../models/ghost';
import { getReadableDate } from '../utils/date';
import { getPostPath } from '../utils/post-helper';

const PostListItemWrapper = styled.div`
  display: flex;
  flex-direction: row;

  img {
    width: 100px;
    height: auto;
  }
`;

const PostListItemContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-items: center;
  flex: 1;
  padding-left: 1rem;

  h3 {
    margin: 0;
  }
`;

interface PostListItemProps {
  image: string;
  title: string;
  publishDate: string;
  description?: string;
}

const PostListItem: React.FC<PostListItemProps> = ({ image, title, publishDate, description }) => {
  return (
    <PostListItemWrapper>
      <div>
        <img src={image} />
      </div>
      <PostListItemContent>
        <h3 className='heading'>{title}</h3>
        {description ? <div>{description}</div> : null}
        <div className='text-muted'>{getReadableDate(publishDate)}</div>
      </PostListItemContent>
    </PostListItemWrapper>
  );
};

const PostListWrapper = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;

  li:not(:first-child) {
    margin-top: 1rem;
  }
`;

const PostList: React.FC<{
  posts: Partial<GhostPost>[];
}> = ({ posts }) => {
  return (
    <PostListWrapper>
      {posts.map((post, index) => (
        <li key={post.id}>
          <Link to={getPostPath(post.slug || '', post.published_at || '')}>
            <PostListItem
              title={post.title || ''}
              image={post.feature_image || ''}
              publishDate={post.published_at || ''}
            />
          </Link>
        </li>
      ))}
    </PostListWrapper>
  );
};

export default PostList;
